import React from 'react';

import { useSelector } from "react-redux";
import { getIsAmendSiteContactEnabled } from "features/order-tracker/store/selectors";
import {
  AppointmentDetails,
  Calendar,
  AvailableSlotsInfo,
  ContactDetails,
  SaveAmendsButton,
} from './components';

import styles from './styles.module.scss';

export const AmendAppointment: React.FC = () => {
  const isAmendSiteContactEnabled = useSelector(getIsAmendSiteContactEnabled);

  return (
    <>
      <AppointmentDetails />
      <div className={styles.dateAndSlotPickerContainer}>
        <Calendar />
        <AvailableSlotsInfo />
      </div>
      { isAmendSiteContactEnabled && <ContactDetails /> }
      <SaveAmendsButton />
    </>
  );
};
